
import { JSX } from 'react';
import { CareerTableValueCell } from '../tableCells';
import { StringToAnyMap } from '../../../types/common';


export interface CareerTableColumnCellProps {
  row: StringToAnyMap;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;

  isNationalTeam?: boolean;
  isExpanded?: boolean;
  language?: string;
}


export interface CareerTableCellProps extends CareerTableColumnCellProps {
  property: 'appearances' | 'games_started' | 'position' | 'n_goals' | 'n_assists';
}


interface CareerTableColumn {
  key: string;
  width: number;
  cell: (props: CareerTableColumnCellProps) => JSX.Element;
  paddingRight?: number;
}


export const careerTableStickyColumnWidth = 330;
export const careerTableStaticColumnsWidth = 280;
export const careerTableDynamicColumnsWidth = 180;
export const careerTablePadding = 15;
export const getCareerTableColumns = (isGoalkeeper: boolean): CareerTableColumn[] => {

  const positionColumnPaddingRight = isGoalkeeper ? careerTablePadding : 0;
  const columns: CareerTableColumn[] = [
    {
      key: 'matches',
      width: 90,
      cell: (props: CareerTableColumnCellProps) => (
        <CareerTableValueCell
          row={props.row}
          property={'appearances'}
          onMouseEnter={props.onMouseEnter}
          onMouseLeave={props.onMouseLeave}
          onClick={props.onClick}
          isNationalTeam={props.isNationalTeam}
          isExpanded={props.isExpanded}
        />
      ),
    },
    {
      key: 'starts',
      width: 90,
      cell: (props: CareerTableColumnCellProps) => (
        <CareerTableValueCell
          row={props.row}
          property={'games_started'}
          onMouseEnter={props.onMouseEnter}
          onMouseLeave={props.onMouseLeave}
          onClick={props.onClick}
          isNationalTeam={props.isNationalTeam}
          isExpanded={props.isExpanded}
        />
      ),
    },
    {
      key: 'position',
      width: 100 + positionColumnPaddingRight,
      cell: (props: CareerTableColumnCellProps) => (
        <div className='table-cell' style={{ paddingRight: positionColumnPaddingRight }}>
          <CareerTableValueCell
            row={props.row}
            property={'position'}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            onClick={props.onClick}
            isNationalTeam={props.isNationalTeam}
            isExpanded={props.isExpanded}
            language={props.language}
          />
        </div>
      ),
      paddingRight: positionColumnPaddingRight,
    },
  ];

  if (!isGoalkeeper) {
    columns.push(
      {
        key: 'goals',
        width: 90,
        cell: (props: CareerTableColumnCellProps) => (
          <CareerTableValueCell
            row={props.row}
            property={'n_goals'}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            onClick={props.onClick}
            isNationalTeam={props.isNationalTeam}
            isExpanded={props.isExpanded}
          />
        ),
      },
      {
        key: 'assists',
        width: 90 + careerTablePadding,
        cell: (props: CareerTableColumnCellProps) => (
          <div className='table-cell' style={{ paddingRight: careerTablePadding }}>
            <CareerTableValueCell
              row={props.row}
              property={'n_assists'}
              onMouseEnter={props.onMouseEnter}
              onMouseLeave={props.onMouseLeave}
              onClick={props.onClick}
              isNationalTeam={props.isNationalTeam}
              isExpanded={props.isExpanded}
            />
          </div>
        ),
        paddingRight: careerTablePadding,
      },
    );
  }

  return columns;
};
